export const FreeShipMethodID = "16";
export const DefaultShipMethodID = "1";
export const FlatRateShipMethodID = "";
export const FreeEnrollmentItemID = "9999";  // Paid enrollment - $59.95
export const FreeEnrollmentZeroPriceItemID = "8888";  // Free enrollment - $0
export const FreeEnrollmentZeroPriceItemID2 = "ENROLL009GUFOFOXSMOF";  // Free enrollment - $0 (alias)
export const DefaultCountry = "US";
export const CORPORATESTOREID = "1";
export const RETAILSTOREID = "3";
export const IBOSTOREID = "4";
export const AUTOSHIPSTOREID = "5";
export const MONTHLYFREQUENCYID = "2";
export const YEARLYFREQUENCYID = "4";